import { render, staticRenderFns } from "./ScoreComponent.vue?vue&type=template&id=ea85982e&"
import script from "./ScoreComponent.vue?vue&type=script&lang=js&"
export * from "./ScoreComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports